var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(_vm._s(Array.isArray(_vm.value) ? _vm.value.length > 0 ? _vm.value.join(',') : '--' : _vm.value ? _vm.value : '--'))])}
var staticRenderFns = []

export { render, staticRenderFns }